import { Organization as OrganizationViewModel } from '../../viewModels/Organization';
import { Organization as GraphqlOrganization } from '../generated/types';
import { mapToFolderListViewModel } from './folder';
import { mapToLicenseSystemViewModel } from './licenseSystem';
import { mapToModuleLicenseViewModel } from './module';
import { mapToUserListViewModel } from './user';

export const mapToOrganizationViewmodel = (source: GraphqlOrganization): OrganizationViewModel => {
    return {
        address: source.address,
        city: source.city,
        code: source.code,
        contactEmail: source.contactEmail,
        contactPerson: source.contactPerson!,
        contactPhone: source.contactPhone!,
        country: source.country,
        id: source.id!,
        name: source.name,
        registration: source.registration,
        zip: source.zip,
        users: source.users ? mapToUserListViewModel(source.users!) : [],
        groups: source.groups ? source.groups! : [], // TODO: introduce group viewmodel + mapper
        rootFolders: source.rootFolders ? mapToFolderListViewModel(source.rootFolders!, 0) : [],
        moduleLicenses: {
            modules: mapToModuleLicenseViewModel(source.licenses ?? []),
        },
        licenseSystems: mapToLicenseSystemViewModel(source.licenseSystems ?? []),
        isAllowedToUseLicenseSystemsOffline: source.isAllowedToUseLicenseSystemsOffline ?? false,
        isSiteOrganization: !!(source.parentOrgId ?? source.parentOrgData?.id),
        parentOrgId: source.parentOrgId ?? source.parentOrgData?.id ?? undefined,
        isHeadOrganization: !!source.isHeadOrganization,
        parentOrgData: source.parentOrgData ? { id: source.parentOrgData.id, name: source.parentOrgData.name } : undefined,
    };
};

// TODO: Separate single organization and organization list view models.
export const mapToOrganizationListViewmodel = (source: Array<GraphqlOrganization>): Array<OrganizationViewModel> =>
    source.map(mapToOrganizationViewmodel);

